import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { PersonaTypings } from '@core/typings/persona.typing';
import { I18nService } from '@yourcause/common/i18n';
import { YCModalComponent } from '@yourcause/common/modals';

///
/// Component places the PersonaQuestionAndAnswersComponent into a modal to allow for editing/adding of responses.
/// AddEditPersonaAnswersModalComponent is used for the MyNonprofits area and for a user's unanswered questions when logging in
///

@Component({
    selector: 'yc-add-edit-persona-answers-modal',
    templateUrl: './add-edit-persona-answers-modal.component.html',
    styleUrls: ['./add-edit-persona-answers-modal.component.scss'],
    standalone: false,
    encapsulation: ViewEncapsulation.None
})

export class AddEditPersonaAnswersModalComponent extends YCModalComponent<null | boolean> implements OnInit {
  //  Will either be User or Nonprofit
  //    User: when a user has unanswered questions and they are logging in
  //    Nonprofit: when a user is modifying their responses to a particular nonprofit
  @Input() personaQuestionAndAnswerType: PersonaTypings.PersonaQuestionAndAnswerTypes;

  //  The specific org the personaQuestionAndAnswerType corresponds to when it is Nonprofit and not User
  @Input() nonprofitId?: number;
  @Input() nonprofitName?: string = null;

  @Input() unansweredQuestionsOnly: boolean = false;

  @Input() newUser: boolean = false;

  //  When personaQuestionAndAnswerType is User, the primary won't be enable until all questions have responses.
  //  This is always false if the personaQuestionAndAnswerType is Nonprofit
  primaryDisabled: boolean = true;

  title: string = '';

  helpLink = 'https://webfiles.blackbaud.com/files/support/helpfiles/npoconnect/content/npo-manage-your-profile.html';

  constructor (
      private i18n: I18nService
  ) {
    super();
  }

  ngOnInit () {
    this.title = this.newUser ?
      //  Unanswered Questions for new users
      this.i18n.translate(
        'account:SetUpYourProfile',
        {},
        'Set Up Your Profile'
      ) :
      //  Unanswered Questions for existing users
      // MyNonprofits - Update your profile nonprofit action
      this.i18n.translate(
        'account:UpdateYourProfile',
        {},
        'Update Your Profile'
      );

    this.primaryDisabled = this.unansweredQuestionsOnly ?
      true :
      false;
  }

  setPrimaryDisabled (primaryDisabled: boolean) {
    if (!this.unansweredQuestionsOnly) {
      this.primaryDisabled = false;
    } else {
      this.primaryDisabled = primaryDisabled;
    }
  }

  //  closes the modal; presented only if personaQuestionAndAnswerType is Nonprofit
  _goBack () {
    this.closeModal.emit();
  }

  //  closes the modal and will lead to user being signed in; presented only if personaQuestionAndAnswerType is User and all unanswered questions have responses
  _signIn () {
    this.closeModal.emit(true);
  }
}
